import { useEffect, useRef, useState } from "react";
import PartList, { ListOptions } from "./PartList";
import PartEdit from "./PartEdit";
import { MDSplitView } from "@solsys/solsys-reactjs";

export default function PartController({
  navigate,
  action,
  id,
  search,
  style,
}) {
  let listState = {
    [ListOptions.sortBy]: "created_at",
    [ListOptions.sortDirection]: "DESC",
    [ListOptions.partNo]: null,
    [ListOptions.craneId]: null,
    [ListOptions.sourceType]: null,
  };
  const didMount = useRef(false);
  useEffect(() => (didMount.current ? undefined : (didMount.current = true)));
  if (!didMount.current && Object.keys(search).length) {
    Object.keys(ListOptions).forEach((key) => {
      listState[key] = search[key];
    });
  }

  listState = useState(listState);

  const effectiveAction = !action && !id ? "list" : action;

  return (
    <div className="parts">
      <MDSplitView
        globalName="PartMDV"
        style={ style }
        action={ effectiveAction }
        master={ ({ isNarrow, autoSelect }) => (
          <PartList
            isMaster
            state={ listState }
            id={ id }
            action={ effectiveAction }
            onStateChange={ (state) => {
              navigate({
                action: effectiveAction,
                id,
                search: state,
                push: false,
              });
            } }
            onSelect={ (newId, userInteraction) => {
              if (
                newId &&
                id &&
                String(newId) === String(id) &&
                userInteraction
              ) {
                navigate({
                  popOut: isNarrow,
                  action: "list",
                  id: null,
                  search: listState[0],
                });
              } else if (newId) {
                navigate({
                  popOut: isNarrow,
                  action: "edit",
                  id: newId,
                  search: listState[0],
                });
              }
            } }
          />
        ) }
        detail={ () => (
          id ? (
            <PartEdit key={ `part-${id}` } id={ id } />
          ) : (
            <div style={ { padding: "1rem" } }>
              Select a part from the list to view details and its related ticket or service.
            </div>
          )
        ) }
        initialWidth={ 340 }
        maxWidth={ 900 }
        minWidth={ 300 }
      />
    </div>
  );
}
